import {DashTextLabel} from './DashLabel';

export default DashTextLabel;